import React from 'react';
import { ChevronUp, ListOrdered, Paperclip } from 'lucide-react';
import { QueuedChatMessage } from '@/types';

interface QueuedMessagesBarProps {
  queuedMessages: QueuedChatMessage[];
  onExpand: () => void;
}

const buildPreview = (message: QueuedChatMessage) => {
  const normalized = message.content.replace(/\s+/g, ' ').trim();
  return normalized || 'Queued attachment';
};

const QueuedMessagesBar: React.FC<QueuedMessagesBarProps> = ({ queuedMessages, onExpand }) => {
  if (queuedMessages.length === 0) {
    return null;
  }

  const nextMessage = queuedMessages[0];
  const attachmentCount = nextMessage.attachments?.length || 0;
  const countLabel = queuedMessages.length === 1 ? '1 Queued' : `${queuedMessages.length} Queued`;

  return (
    <button
      type="button"
      onClick={onExpand}
      className="w-full border-b border-border/70 px-3 py-2 text-left transition-colors hover:bg-muted/20"
    >
      <div className="flex items-center gap-2 text-sm">
        <ListOrdered className="h-4 w-4 shrink-0 text-muted-foreground" />
        <span className="font-semibold text-foreground">{countLabel}</span>
        <span className="text-muted-foreground">- will send after current response</span>
        <ChevronUp className="ml-auto h-4 w-4 shrink-0 text-muted-foreground" />
      </div>

      <div className="mt-2 flex items-center gap-2 rounded-md bg-muted/30 px-3 py-2 text-sm">
        <span className="min-w-0 flex-1 truncate text-foreground">{buildPreview(nextMessage)}</span>
        {attachmentCount > 0 ? (
          <span className="flex shrink-0 items-center gap-1 text-muted-foreground">
            <Paperclip className="h-3.5 w-3.5" />
            <span>{attachmentCount}</span>
          </span>
        ) : null}
      </div>
    </button>
  );
};

export default QueuedMessagesBar;
